export interface Payment {
  id: number;
  date: string;
  title: string;
  project: string;
  amount: number;
  status: 'Pagado' | 'Pendiente' | 'Retrasado' | 'En proceso';
  description?: string;
  type?: number;
  sharePremiumOrRedemption?: number;
  profitOrInterest?: number;
  showBreakdown?: boolean;
  //category: string;
}

export interface StatusConfig {
  label: string;
  color: string; // Clase de Tailwind CSS basada en tu config
}

export interface DisplayDay {
  date: Date;
  dayOfMonth: number;
  dayOfWeek: number;
  payments: Payment[];
  isCurrentMonth: boolean;
}

export type YearDay = { day: number; hasEvent: boolean } | null;
export interface YearMonth {
  year: number;
  month: number;           // 0‑11
  days: YearDay[];         // longitud múltiplo de 7
}